export const ROOT_PATH_RESERVATIONS= 'reservations';

export const ReservationsRoutes = {
    RESERVATIONS: {path: '', fullPath: `/${ROOT_PATH_RESERVATIONS}`},
    RESERVATION_REVIEW: {path: 'review', fullPath: `/${ROOT_PATH_RESERVATIONS}/review`}, 
    RESERVATION_CONFIRMATION: {path: 'confirmation', fullPath: `/${ROOT_PATH_RESERVATIONS}/confirmation`}, 
}